 <style lang="less">
	video{
		max-width: 100% !important;
		background-repeat: no-repeat;
		margin-right: auto;
		margin-right: auto;
	}
	#loading{
		margin-right: auto;
		margin-right: auto;
		position: absolute;
		left: 40%;
		top: 20%;
	}
	#mainVideo video{
		width: 150%;
		height: 150%;
	}
	.video-wrapper{
	}
 </style>
<template>
	<div>
		<v-row>
			<v-progress-circular
			v-if="loading"
			:size="70"
			:width="7"
			indeterminate
			color="primary"
			id="loading"
			></v-progress-circular>
		</v-row>
		<v-row  v-if="live">
			<v-col cols="12" sm="6" md="8">
				<v-card class="video-wrapper pa-2 mb-2" style="min-height: 300px;">
					<div id="mainVideo">
						<p class="mt-5 pt-5 text-center display-1 font-weight-thin"> Awaiting {{ view == 'participant' ? 'researcher' : 'participants'}}</p>
					</div>
				</v-card>
			</v-col>
			<v-col cols="12" sm="6" md="4" >
				<v-card class="video-wrapper pa-2" style="min-height: 170px;">
					<div id="sideVideos">
					</div>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-else>
			<v-col cols="12">
				<v-alert type="info" outlined colored-border border-left color="primary">
					Video not in progress
				</v-alert>
			</v-col>
		</v-row>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import firebase from "firebase";
	import Twilio, { connect, createLocalTracks, createLocalVideoTrack, LocalVideoTrack } from 'twilio-video';
	createLocalVideoTrack;
	LocalVideoTrack;
	createLocalTracks;
	connect;
	Twilio;

	export default {
		name: "Video",
		props: {
			live: {type: Boolean, default: false}, 
			shareScreen: {type: Boolean, default: false}, 
			roomIdentity: { type: String },
			recording: {type: Boolean, default: false}, 
			joinAs: {type: String}
		},
		// emits:{
			// videoStarted
			// videoEnded
			// screenSharingStarted
			// screenSharingEnded
			// startRecording
			// endRecording
		// },
		data: () =>{
			return {
				mainTrack: false, 
				screenShareTrack: false,
				loading: false, 
				activeRoom: false,
				session: false
			}
		}, 
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user
			}),
		},
		methods: {
			async getAccessToken(){
				const self = this;
				var functions = firebase.app().functions('europe-west1');
				var requestVideoToken = functions.httpsCallable('requestVideoToken');
				return await requestVideoToken({roomName: self.roomIdentity, identity: self.user.uid});
			},
			async startScreenSharing(){
				const self = this;
				const stream = await navigator.mediaDevices.getDisplayMedia();
				const screenTrack = new LocalVideoTrack(stream.getTracks()[0]);
				stream.getTracks()[0].onended = function () {
					self.$emit("screenSharingEnded")
				};
				self.screenShareTrack = screenTrack;
				self.activeRoom.localParticipant.publishTrack(screenTrack);
				self.addSingleTrackToCall(screenTrack);
				this.$emit("screenSharingStarted")
			},	
			endScreenSharing(){
				const self = this;
				if(  !self.screenShareTrack ){ return }
				self.activeRoom.localParticipant.unpublishTrack(self.screenShareTrack);
				self.removeSingleTrackFromCall(self.screenShareTrack)
			},
			addSingleTrackToCall(track){
				const self = this;
				let wrapper = document.getElementById("sideVideos");
				if( !wrapper ){ return  }
				let child = wrapper.appendChild(track.attach())
				child.addEventListener("click", function(){ 
					child.remove();
					self.makeMainTrack(track)
				} ) 
			},
			removeSingleTrackFromCall(track){
				if( !track ){return;}
				track.detach().forEach(function(element) {
					element.remove();
				});

			},
			newSingleTrackPublished(publication){
				const self = this;
				if (publication.isSubscribed) {
					if( !self.mainTrack){
						self.makeMainTrack( publication.track );
					}
					else{
						self.addSingleTrackToCall(publication.track);
					}					
					
				}
				publication.on('subscribed', function(track) {
					if( !self.mainTrack){
						self.makeMainTrack( track );
					}
					else{
						self.addSingleTrackToCall(track);
					}
				});
				publication.on('unsubscribed', function(track) { 
					self.removeSingleTrackFromCall(track)
				});
			},
			makeMainTrack: function(track){
				const self = this;
				document.getElementById("mainVideo").innerHTML = "";
				if( self.mainTrack ){
					self.addSingleTrackToCall( self.mainTrack );
				}
				self.mainTrack = track;
				document.getElementById("mainVideo").appendChild(self.mainTrack.attach())
			},			
			newLocalParticipant(){
				const self = this;
				let tracks = self.getParticipantTracks(self.activeRoom.localParticipant); 
				tracks.forEach( track => self.addSingleTrackToCall( track ))
			},
			newRemoteParticipant(participant){
				const self = this;
				participant.tracks.forEach(function(publication) {
					self.newSingleTrackPublished(publication);
				});				
				participant.on('trackPublished', function(publication) {
					self.newSingleTrackPublished(publication)
				});
				participant.on('trackUnpublished', function(publication) {
					self.removeSingleTrackFromCall(publication.track)
				});

			},
			participantLeaves(participant){
				// const self = this;
				participant;
			},
			getParticipantTracks(participant) {
				return Array.from(participant.tracks.values()).filter(function(publication) {
					return publication.track;
				}).map(function(publication) {
					return publication.track;
				});
			},		
			endVideoCall(){
				const self = this;
				if( self.activeRoom ){
					self.participantLeaves(self.activeRoom.localParticipant)
					self.activeRoom.disconnect();
					self.activeRoom = null;
					self.recording = false;
				}
				self.$emit("endRecording")
				self.$emit("videoEnded")
			},					
			startANewVideoCall(){
				const self = this;

				if( !self.user.uid ){ return; }
				if( !self.roomIdentity ){ return; }
				const identity = self.user.uid;

				self.loading = true;
				self.getAccessToken(self.roomIdentity, identity).then( (data) => { 
					const token = data.data.token;
					let connectOptions = {
						name: self.roomIdentity,
						audio: !(self.joinAs == "observer"),
						video: !(self.joinAs == "observer"),
						RecordParticipantsOnConnect: true
					};

					Twilio.connect(token, connectOptions).then(function(room) {
						self.activeRoom = room;
						self.loading = false;
						self.$emit("videoStarted", room.sid )
						self.$emit("startRecording")
						if( self.joinAs !== "observer" ){
							self.newLocalParticipant();
						}

						room.participants.forEach(function(participant) {
							self.newRemoteParticipant(participant);
						});

						room.on('participantConnected', participant => {
							self.newRemoteParticipant(participant);
						});

						room.on('participantDisconnected', participant => {
							self.participantLeaves(participant);
						});
						room.on('disconnected', function() {
							self.endVideoCall();
							self.$emit("left")
						});

					})

				})

			}

		},
		watch: {
			live: {
				immediate: true, 
				handler: function(live){
					const self = this;
					if( live ){
						self.$store.dispatch("addDoc", {
							collection: "videoSessions",
							data: {
								appointment: self.roomIdentity, 
								user: self.user.uid, 
								role: self.user.role
							}
						}).then((ref) => {
							self.session = ref.id;
							self.startANewVideoCall( )
						})

					}
					else{
						this.endVideoCall( )
					}
				}
			},
			shareScreen: {
				immediate: true, 
				handler:function(shareScreen){
					if( shareScreen ){
						this.startScreenSharing( )
					}
					else{

						this.endScreenSharing( )
					}
				}
			}

		},
		destroyed: function(){
			this.endVideoCall( )

		}
	}		
</script>